import { channelClient, RequestPolicies } from 'shared/channels';
import { projectDataContract } from './projectDataContract';
import type { ProjectDataDownloadProgress, ProjectDataKey } from './projectDataModel';

/** The download of the selected project's data in the worker. */
export const projectDataClient = {
  /** Resolves once the data is downloaded. Rejects with `ChannelRequestError` when the download failed. */
  ensureDownloaded(key: ProjectDataKey): Promise<void> {
    return channelClient.request(projectDataContract, 'ensureDownloaded', key, RequestPolicies.projectDownload);
  },

  /** Where each download stands; the worker starts again the ones that stopped. */
  continueDownload(keys: ProjectDataKey[]): Promise<ProjectDataDownloadProgress> {
    return channelClient.request(projectDataContract, 'continueDownload', keys, RequestPolicies.read);
  },
};
